module.exports = __webpack_public_path__ + "static/media/asami.8df0d9dc.png";